import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.scss']
})
export class HistoricalDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
